export const getReasons = (state) => state.reasons
